<script>
	import bigpicture from 'bigpicture'

	export let images = []

	const { Macy } = window

	function mount() {
		var macy = Macy({
			container: '#img_grid',
			margin: 10,
			columns: 3,
			breakAt: {
				700: 2,
				400: 1,
			},
		})
	}

	function openLightbox(e) {
		e.preventDefault()
		bigpicture({
			el: e.target,
			gallery: '#img_grid',
		})
	}
</script>

<div class="show-images" use:mount id="img_grid">
	{#each images as image}
		<div style="background-image: url({image.sm});">
			<a
				href={image.lg}
				style="padding: 0 0 {(image.height / image.width) * 100}%"
				target="_blank"
				rel="noopener noreferrer"
				data-bp={image.lg}
				data-caption={image.caption}
				on:click={openLightbox}>
				<span class="sr-only">{image.alt}</span>
			</a>
		</div>
	{/each}
</div>
